/**
 * Animate scroll to top button in/off view
 */

import throttle from '../../../js/utilities/functions/throttle.js'

let button = document.querySelector('.btn-scroll-top'),
  progress = button.querySelector('svg rect')

if (button instanceof HTMLElement && progress instanceof SVGRectElement) {
  const scrollOffset = 500,
    length = progress.getTotalLength?.() ?? 155 // in mobile Webview: getTotalLength() does not exist

  progress.style.strokeDasharray = length
  progress.style.strokeDashoffset = length

  const showProgress = () => {
    let scrollPosition = window.pageYOffset,
      scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight,
      scrollPercent = scrollPosition / scrollHeight || 0,
      draw = length * scrollPercent
    progress.style.strokeDashoffset = length - draw
  }

  const toggleButtonVisibility = () => {
    if (window.pageYOffset > scrollOffset) {
      button.classList.add('show')
    } else {
      button.classList.remove('show')
    }
  }

  const throttledToggleButtonVisibility = throttle(toggleButtonVisibility, 100)

  const handleScroll = () => {
    throttledToggleButtonVisibility()
    showProgress()
  }

  window.addEventListener('scroll', handleScroll)
}
